const locale = `
# ***********************************************
# FAQ
# ***********************************************
faq = Frequently Asked Questions
faq_text = Frequently Asked Questions

  If you have other questions, you could contact our support team.
  Just use command /help to get support chat link.

  Please select your question:
faq_not_found = Question or answer not found

faq_why_choose_question = Why should I choose your card?
faq_why_choose_button = Why should I choose your card?
faq_why_choose_answer = The choice is always yours, but we have several advantages over any other services:

  1. Low top-up fees: our fees are significantly lower than competitors.
  2. No hidden charges: 0% purchase fees, free token conversion, and notifications.
  3. We constantly use our cards ourselves and know what else needs improvement.
  4. Human approach: no scripts or bureaucracy, we are always ready to help, listen to your suggestions or comments, and implement good ideas!


faq_how_to_get_question = How do I get a card?
faq_how_to_get_button = How do I get a card?
faq_how_to_get_answer = To get a card, you only need to purchase it through our bot. Follow these steps:

  1. Open the bot commands menu and use command /virtualcard for ordering.
  2. Select the appropriate plan (the difference is in the issuance cost and top-up fee).
  3. Complete the USDT transaction on TRON network (TRC20) to the provided address (the address is copied when you click on it)
  4. Your card will be issued instantly after transaction confirmation and will be valid for 5 years.

  ⚠️ In case of high demand for cards, the issuance time may increase up to 24 hours.

faq_how_to_top_up_question = How do I top up the card?
faq_how_to_top_up_button = How do I top up the card?
faq_how_to_top_up_answer = To top up your virtual card, you need to follow these steps:

  1. Open the bot commands menu and use command /topup.
  2. Transfer USDT on TRON network  (TRC20) to the provided address (the address is copied when you click on it).
  3. If the transfer amount is sufficient, the top-up fee will be automatically deducted, and the remaining amount will be credited to your selected card.
  4. After the funds are credited to the card balance, you will receive a notification in the chat with the bot.

  Top-up conditions:
  Minimum top-up amount:
  - Virtual cards: 25 USDT for all plans.
  - Physical cards: 35 USDT for all plans.
  Fixed fee: 10 USDT for all plans.
  Variable fee: depends on the selected card plan (1%-2% of the top-up amount).

  ⚠️ Fixed commission of 10 USDT is required due to the internal necessity of purchasing TRX for further token transfers.
  In case of significant changes in the TRX to USDT exchange rate, the commission may be revised.
  This may also affect the minimum top-up amount for the card.

faq_cards_number_question = How many cards can I have?
faq_cards_number_button = How many cards can I have?
faq_cards_number_answer = Currently, only 1 card per account could be added automatically.

  Additional cards require manual approval by our support team.
  We are working on removing this limitation to make our service easier to use.

faq_wallets_question = How do I add my card to Apple Pay or Google Wallet?
faq_wallets_button = How do I add my card to Apple Pay or Google Wallet?
faq_wallets_answer = ✅ Google Wallet: You can add your card and start paying instantly.

  ⚠️ Apple Pay:
  Virtual and physical cards issued before August 19, 2025 can be added without issues.
  Virtual cards issued in the Hong Kong jurisdiction after August 19, 2025 due to a temporary restriction cannot be added to Apple Pay at the moment.

  ❗️ Due to circumstances beyond our control, virtual cards issued in the Hong Kong jurisdiction cannot be added to Apple Pay after August 19, 2025.
  We are working on issuing virtual cards in other jurisdictions and will try to resolve this issue within the next month.

  Verification method:
  When adding the card, always choose Email as the verification option!
  You do not need to use your own personal email.
  The confirmation code OTP will be automatically delivered to our system and shown directly in the bot.
  You only need to wait for the confirmation message — no manual entry is required.

  Our recommendation:
  If you are an iOS user, we suggest having a small, inexpensive Android device as a backup.
  This ensures you always have access to Google Wallet, which fully supports all cards.

faq_paypal_question = How do I add my card to PayPal?
faq_paypal_button = How do I add my card to PayPal?
faq_paypal_answer = To add your card to PayPal, follow these steps:
  Go to your PayPal Wallet → Link a Card.
  Enter your card details.
  In the bot, press Confirm.
  Wait for the confirmation message.
  If it fails, retry the confirmation process until successful.

faq_safety_question = Is it safe to use these cards?
faq_safety_button = Is it safe to use these cards?
faq_safety_answer = Yes, it is completely safe.

  All cardholder data is encrypted and securely stored.  
  Only the end client has access to sensitive details.

faq_kyc_question = KYC (Know Your Customer) – When is it required?
faq_kyc_button = KYC (Know Your Customer)
faq_kyc_answer = Normally, no documents are required.

  In case of suspicious or high-risk activity, we may request:
  - Passport/ID copy
  - Proof of address

  This process ensures the security of all users.

faq_recurring_payments_question = Recurring Payments Warning
faq_recurring_payments_button = ❗️ Recurring Payments
faq_recurring_payments_answer = Do not link your card to services that may create frequent recurring payments of the same amount!

  This is not an issue for regular monthly or weekly subscriptions, which do not raise suspicions with the bank's security service.  
  However, multiple identical charges within a single day may cause problems.

  This is especially important when paying for ads on Facebook or Google.

  Multiple identical charges to the same merchant may trigger temporary card blocks by bank security.  
  In that case, you may need to verify your identity and the source of funds with the bank through our support team.  
  Unlocking your card may take up to 30 days depending on the bank's support.

  To avoid problems:
  - Always preload your account balance with an advance payment.
  - Vary the amounts and frequency of transactions.
  
  For your safety:
  - Do not store large balances on your card (blockchain is safer than banks in most cases).
  - Only top up according to your actual spending.

  These measures are designed to protect you against fraud and service interruptions.

faq_aml_question = AML (Anti-Money Laundering) Policy
faq_aml_button = AML (Anti-Money Laundering) Policy
faq_aml_answer = Anti-Money Laundering (AML) compliance is mandatory for our system to operate.  
  Using the card for any criminal, fraudulent, or high-risk activity is strictly prohibited.

  🚫 Forbidden activities:
  - Money laundering of any kind
  - Funding terrorism or extremist organizations
  - Running scams, fraud, or Ponzi schemes
  - Using stolen, hacked, or illegally obtained cryptocurrency
  - Transactions linked to darknet markets, drugs, weapons, or illegal services
  - Hiding or "layering" funds to disguise their source

  🔍 Monitoring & Enforcement:
  - Every transaction is automatically monitored by our system.
  - Suspicious activity will result in immediate card suspension.
  - Large or unusual transactions may be held for manual review.
  - Authorities may be informed if illegal activity is detected.

  ⚖️ Consequences for violations:
  - Cards used for crime will be permanently blocked.
  - Any criminally sourced funds will be seized and returned to rightful owners or authorities.
  - No refunds will be issued for fees paid by violators.
  - Repeat offenders will be banned from our services permanently.

  ✅ Your responsibility:
  - Always use only legitimate funds.
  - Ensure your top-ups come from transparent and legal sources.
  - Understand that by using our service, you agree to full AML compliance.

# ***********************************************
# Landing Page
# ***********************************************

# Hero Section
hero_title = International payments are available again
hero_subtitle = Get a virtual Visa card that works without restrictions.
  Pay for foreign services and travel freely by topping up your balance in USDT
hero_button = Choose a card

# Problem Section
problem_title = Familiar situation?
problem_subtitle = When your usual cards no longer work, you need a reliable solution.
problem_item_1 = Your Visa/Mastercard cards are not accepted abroad
problem_item_2 = It's difficult to pay for subscriptions to familiar foreign services and purchases
problem_item_3 = During vacation, you have to carry cash and look for exchange offices
problem_conclusion = Our card, topped up with cryptocurrency, solves these problems.
  This is your personal financial tool that
problem_conclusion_highlight = does not depend on sanctions or the banking systems of your country.

# Use Cases Section
usecases_title = Where will the card come in handy?
usecases_payment_title = Payment for foreign services
usecases_payment_desc = Regain access to familiar services: Adobe, Figma, Steam, Spotify, Netflix, Booking and others
usecases_travel_title = Free payments while traveling
usecases_travel_desc = Travel without a stack of cash. Pay with your card at hotels, restaurants and shops in any country
usecases_ads_title = Advertising campaigns and accounts
usecases_ads_desc = Stable payment for advertising on Google, TikTok, Facebook, without the risk of blocking your personal card

# Stability Section
stability_title = Stability in unstable times
stability_subtitle = Protect your savings from exchange rate volatility and inflation
stability_reliability_title = Reliability
stability_reliability_desc = Your savings are pegged to the US dollar (USDT) and maximally protected from inflation and exchange rate fluctuations.
stability_security_title = Security
stability_security_desc = The risk of asset blocking in cryptocurrency is significantly lower than in bank accounts.
stability_access_title = Instant access
stability_access_desc = At any time, transfer the required amount from your crypto wallet to the card and use it.
stability_predictability_title = Predictability
stability_predictability_desc = Use the card with pre-known fees throughout its validity period until 2030.

# Pricing Section
pricing_title = Transparent terms and tariffs
pricing_subtitle = Choose the tariff that suits you.
pricing_popular = Most popular

pricing_start_title = Start 🚀
pricing_start_price = 120 USDT
pricing_start_fee = Top-up fee: 2% + 10 USDT
pricing_start_no_tx_fee = No transaction fees
pricing_start_small_expenses = Perfect for small expenses
pricing_start_basic_support = Basic support

pricing_balance_title = Balance ⚖️
pricing_balance_price = 240 USDT
pricing_balance_popular = Most popular
pricing_balance_fee = Top-up fee: 1.5% + 10 USDT
pricing_balance_no_tx_fee = No transaction fees
pricing_balance_optimal = Optimal choice for regular use
pricing_balance_priority_support = Priority support

pricing_premium_title = Premium 💎
pricing_premium_price = 360 USDT
pricing_premium_fee = Top-up fee: 1% + 10 USDT
pricing_premium_no_tx_fee = No transaction fees
pricing_premium_large_payments = For large payments and advertising budgets
pricing_premium_priority_support = Priority support

pricing_one_time_fee = one-time issuance fee
pricing_select_button = Select
pricing_footer_note = This is a **one-time fee** for issuing your financial instrument, which will be valid until 2030.
  A useful investment in your financial freedom and independence.

# Final CTA Section
final_cta_title = Your independent access to global payments
final_cta_subtitle = Start using cryptocurrency in the real world today.
  The card issuance process takes just a few minutes.
final_cta_button = Choose your tariff

# ***********************************************
# Header & Footer
# ***********************************************

# Header
header_features = Benefits
header_pricing = Plans
header_telegram_bot = TELEGRAM BOT

# Footer
footer_title = UCard Bot | Crypto Visa Cards
footer_subtitle = Your bridge between cryptocurrency and the real world.
footer_privacy_policy = Privacy Policy
footer_terms_of_service = Terms of Service
footer_aml_policy = AML Policy
footer_contact_us = Contact Us
footer_telegram_label = Telegram:
footer_copyright = UCard, 2025

`;

export default locale;
